import React, { useEffect, useRef } from "react";

export default function VideoPlayer() {
  const vidRef = React.useRef();
  const vidOutputRef = React.useRef();
  const vidBufferRef = React.useRef();

  useEffect(() => {
    const video = vidRef.current;
    const buffer = vidBufferRef.current.getContext("2d");
    const output = vidOutputRef.current.getContext("2d");
    const width = vidOutputRef.current.width;
    const height = vidOutputRef.current.height;
    const fps = 25;
    const processFrame = () => {
      buffer.drawImage(video, 0, 0);
      var image = buffer.getImageData(0, 0, width, height),
        imageData = image.data,
        alphaData = buffer.getImageData(0, height, width, height).data;
      for (var i = 3, len = imageData.length; i < len; i = i + 4) {
        imageData[i] = alphaData[i - 1];
      }
      output.putImageData(image, 0, 0, 0, 0, width, height);
    };

    const interval = setInterval(() => {
      processFrame();
    }, fps);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <video autoPlay muted loop ref={vidRef}>
        <source
          src={`/digital-assays/assets/video/BioRad_640px_wMatte.mp4`}
          type="video/mp4"
        />
      </video>
      <canvas
        width="640"
        height="1280"
        id="vidBuffer"
        ref={vidBufferRef}
      ></canvas>
      <canvas
        width="640"
        height="640"
        id="vidOutput"
        ref={vidOutputRef}
      ></canvas>
    </div>
  );
}
